<template>
    <div class="dashboard" :class="{ active: openMenu || myState }">
        <SidebarDesktop v-model="openMenu" @logout="logout" />
        <div class="dashboardPage">
            <div class="header mb-2">
                <div class="headerWrap">
                  <div class="greetings">
                    <p class="title">Event Voucher</p>
                    <p class="subtitle">Dapatkan harga yang lebih murah dengan menukarkan vouchermu</p>
                  </div>
                  <div class="notif" @click="notificationClick">
                    <img v-if="!isNewNotification" src="../assets/icons/bell.svg" alt="">
                    <img v-else src="../assets/icons/bell-dot.svg" alt="">
                  </div>
                  <div class="menuMobile" v-if="isMobile()">
                    <div class="menubar" v-if="!openMenuMobile" @click="openMenuMobile = true">
                      <i class="fas fa-bars"></i>
                    </div>
                    <div class="closebar" v-else @click="openMenuMobile = false">
                      <i class="fas fa-times"></i>
                    </div>
                  </div>
                </div>
            </div>
            <div class="pages">
                <Transition name="mobile-drawer">
                  <div
                    v-if="openMenuMobile"
                    class="menuListMobile"
                    @click.self="openMenuMobile = false"
                  >
                    <div class="menuMobilePanel">
                      <div class="menuMobileHeader">
                        <div class="brand" aria-hidden="true">
                          <img
                            class="brandLogo"
                            src="../assets/images/logo-perindo-new.png"
                            alt="Partai Perindo"
                          />
                        </div>

                        <button
                          type="button"
                          class="closeBtn"
                          @click="openMenuMobile = false"
                          aria-label="Close menu"
                        >
                          <img class="toggleIcon" src="@/assets/icons/double-arrow-left.svg" alt="" />
                        </button>
                      </div>

                      <ul class="menu-list mobileMenuBody active">
                        <li class="wrap">
                          <router-link to="/dashboard" class="menu-wrap" @click="openMenuMobile = false">
                            <span class="icon" v-html="menuIcons.home"></span>
                            <div class="text-small">Beranda</div>
                          </router-link>
                        </li>

                        <li class="wrap">
                          <router-link to="/dashboard/dokumen" class="menu-wrap" @click="openMenuMobile = false">
                            <span class="icon" v-html="menuIcons.document"></span>
                            <div class="text-small">Dokumen Partai</div>
                          </router-link>
                        </li>

                        <li class="wrap">
                          <router-link to="/event-voucher" class="menu-wrap">
                            <span class="icon" v-html="menuIcons.event"></span>
                            <div class="text-small">Event Voucher</div>
                          </router-link>
                        </li>

                        <li class="wrap">
                          <router-link to="/dashboard/agenda" class="menu-wrap" @click="openMenuMobile = false">
                            <span class="icon" v-html="menuIcons.agenda"></span>
                            <div class="text-small">Agenda Perindo</div>
                          </router-link>
                        </li>

                        <li class="wrap">
                          <router-link to="/dashboard/pemetaan-lokasi" class="menu-wrap" @click="openMenuMobile = false">
                            <span class="icon" v-html="menuIcons.rumah"></span>
                            <div class="text-small">Rumah Perindo</div>
                          </router-link>
                        </li>

                        <li class="wrap">
                          <router-link to="/dashboard/profil" class="menu-wrap" @click="openMenuMobile = false">
                            <span class="icon" v-html="menuIcons.profile"></span>
                            <div class="text-small">Profile</div>
                          </router-link>
                        </li>
                      </ul>

                      <div class="menu-list mobileMenuFooter active">
                        <div class="wrap" @click="logout(); openMenuMobile = false">
                          <div class="menu-wrap logout">
                            <span class="icon" v-html="menuIcons.logout"></span>
                            <div class="text-small">Keluar</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Transition>

                <Transition name="slide">
                    <MobileNotification v-if="showMobileNotification" @closenotification="closeNotification('mobile')" />
                </Transition>
                <DesktopNotification v-if="showDesktopNotification" @closenotification="closeNotification('desktop')" />
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .greetings {
      display: flex;
      flex-direction: column;
    }
    .title {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: -6px;
    }
    .subtitle {
      font-size: 14px;
    }

.menuListMobile {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.35);
}

.menuMobilePanel {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100vw;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 8px;
}

.menuMobileHeader {
  height: 92px;
  padding: 14px 14px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brandLogo {
  height: 30px;
  width: auto;
  display: block;
}

.closeBtn {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.mobileMenuBody {
  flex: 1 1 auto;
  overflow: auto;
  padding: 12px 14px;
}

.mobileMenuFooter {
  flex: 0 0 auto;
  padding: 0 14px 14px;
}

.mobile-drawer-enter-active,
.mobile-drawer-leave-active {
  transition: opacity 0.25s ease;
}

.mobile-drawer-enter-from,
.mobile-drawer-leave-to {
  opacity: 0;
}

.mobile-drawer-enter-active .menuMobilePanel,
.mobile-drawer-leave-active .menuMobilePanel {
  transition: transform 0.28s ease;
}

.mobile-drawer-enter-from .menuMobilePanel {
  transform: translateX(-100%);
}

.mobile-drawer-leave-to .menuMobilePanel {
  transform: translateX(-100%);
}

    .dashboard {
        display: flex;
        gap: 14px;
        height: 100vh;
        min-height: 100vh;
        align-items: stretch;

        i {
            font-size: 18px;
        }

        .dashboardPage {
            position: relative;
            flex: 1 1 auto;
            width: auto;
            min-width: 0;
            height: 100%;
            max-width: 1400px;
            overflow: auto;
            padding: 24px;

            @media only screen and (min-width: 601px) and (max-width: 800px) {
                width: 83%;
            }

            @media only screen and (max-width: 600px) {
                width: 100%;
                padding: 0px;
                margin-left: -4px;
            }

            .header{
                z-index: 99;
                @media only screen and (max-width: 600px) {
                    position: fixed;

                }
            }
            .headerWrap {

                display: flex;
                justify-content: space-between;
                // z-index: 999;
                @media only screen and (max-width: 600px) {
                  display: grid;
                  grid-template-areas:
                    "bar logo notif";
                  grid-template-columns: auto 1fr auto;

                  width: 100vw;
                  background: #fff;

                  margin: -1rem -1rem 1rem -1rem;

                  padding: 20px 16px;
                  min-height: 88px;

                  align-items: start;
                  column-gap: 12px;
                }

                .greetings {
                  @media only screen and (max-width: 600px) {
                    grid-area: logo;
                    margin-top: 4px;
                  }
                }

                .menuMobile {
                  @media only screen and (max-width: 600px) {
                    grid-area: bar;
                    align-self: start;
                    margin-top: 6px;
                  }
                }

                .logo {
                    height: 72px;
                    width: auto;
                    @media only screen and (max-width: 600px) {
                        height: 48px;
                        width: auto;
                        grid-area: logo;
                    }
                }

                .notif {
                    height: 100%;
                    color: $blue;
                    display: flex;
                    align-items: center;

                    @media only screen and (max-width: 600px) {
                      // display: block;
                      grid-area: notif;
                    }

                    svg {
                      display: flex;
                      align-self: center;
                    }
                }

                .menuMobile {
                    padding: 3px 10px;
                    border-radius: 3px;
                    height: fit-content;
                    background-color: $pale-grey;
                    display: none;

                    @media only screen and (max-width: 600px) {
                        display: block;
                        grid-area: bar;
                    }

                    i {
                        font-size: 14px;
                    }
                }
            }
            .pages{
                 @media only screen and (max-width: 600px) {
                        height: 88vh;
                        padding-top: 12vh;
                    }
            }
        }
    }

    .slide-enter-active {
        transition: all 0.3s ease-out;
    }

    .slide-leave-active {
        transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
    }

    .slide-enter-from {
        transform: translateX(100vw);
    }
    .slide-leave-to {
        transform: translateX(-100vw);
    }
    .icon {
      margin-top: 6px;
      margin-left: 9px;
      width: 24px;
      height: 24px;
    }

    .menu-list {
      margin: 0;
      width: auto;
      padding: 12px;
    }

    .menu-list .wrap {
      list-style: none;
      width: 100%;
      margin-bottom: 10px;
    }

    .menu-list .wrap .menu-wrap {
      white-space: nowrap;
      border-radius: 7px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 6px;
      color: #667085;
    }

    .menu-list .wrap .menu-wrap.router-link-active.router-link-exact-active {
      background-color: #D6DFF4;
      color: #182773;
    }

    .menu-list .wrap .menu-wrap.router-link-active.router-link-exact-active .text-small {
      color: #243E81 !important;
      font-weight: 600;
    }

    .menu-list .wrap .menu-wrap .text-small {
      display: inline-block;
      width: 0;
      overflow: hidden;
      font-size: 14px;
      transition: all 0.35s ease;
      color: #4F515E !important;
      vertical-align: sub;
      padding-left: 0;
      margin-left: 6px;
    }

    .menu-list .wrap .menu-wrap.main {
      background-color: transparent;
    }

    .menu-list.active .text-small {
      width: 150px !important;
      padding-left: 10px !important;
    }

    .menu-list.active .menu-wrap {
      justify-content: flex-start;
      padding-left: 12px;
    }

    .menu-list.active .icon {
      margin-left: 6px;
    }

    .toggleIcon {
      transform: rotate(180deg);
    }
</style>

<script>
import axios from 'axios'
import device from '../mixins/isMobile'
import encoded from '../mixins/encodeForm'
import MobileNotification from '../components/MobileNotification/index.vue'
import DesktopNotification from '../components/DesktopNotification/index.vue'
import SidebarDesktop from '../components/SidebarDesktop.vue'
import { menuIcons } from '../assets/icons/menuIcons.js'

import {
  mapGetters
} from 'vuex'

export default {
  data () {
    return {
      openMenu: true,
      cardisShown: false,
      openMenuMobile: false,
      form: {
        token: ''
      },
      showModal: false,
      showMobileNotification: false,
      showDesktopNotification: false,
      isNewNotification: false,
      menuIcons
    }
  },
  //   components: { modalConfirm },
  mixins: [device, encoded],
  mounted () {
    this.form.token = this.$store.state
    this.getStateNotification()
    setInterval(() => {
      this.getStateNotification()
    }, 20000)
  },
  watch: {
    $route (newVal, old) {
      // this.logger(newVal, old)
      this.openMenuMobile = false
    }
  },
  computed: {
    ...mapGetters({
      myState: 'getMyState'
    }),
    profile () {
      return this.$store.state.profile
    }
  },
  methods: {
    async logoutMethod () {
      const token = this.$store.state.token
      const logout = await axios.post('auth/logout', { token })
      if (logout.status === 200) {
        this.$store.commit('showGlobalAlert', {
          message: 'Berhasil Logout',
          type: 'success'
        })
        await this.$cookie.removeCookie('token')
        await this.$store.commit('setIsLogin', false)
        await this.$store.commit('setProfile', null)
        this.$router.push({ name: 'Login' })
      }
      // logout nya masih error jadi either paksa logout
      await this.$cookie.removeCookie('token')
      await this.$store.commit('setIsLogin', false)
      await this.$store.commit('setProfile', null)
      this.$router.push({ name: 'Login' })
      this.$store.commit('setShowAlert', false)
    },
    async logout () {
      this.alertConfirmation('Anda akan keluar dari aplikasi, apakah anda yakin ingin melanjutkan ?', this.logoutMethod.bind(this))
    },
    async notificationClick () {
      await axios.put('notification/notification/newnotificationstate')
      this.getStateNotification()

      if (this.isMobile()) {
        this.showMobileNotification = true
      } else {
        this.showDesktopNotification = true
      }
    },
    closeNotification (screen) {
      const appEl = document.getElementById('app')
      appEl.style.overflow = 'auto'
      if (screen === 'mobile') {
        this.showMobileNotification = false
      } else {
        this.showDesktopNotification = false
      }
    },
    async getStateNotification () {
      const { data: { data } } = await axios.get('notification/notification/newnotificationstate')
      this.isNewNotification = data.State
    }
  },

  components: { MobileNotification, DesktopNotification, SidebarDesktop }
}
</script>
